export enum JubliaAIRedirectEnum {
  PEOPLE = 'PEOPLE', // login and available
  COMPANY = 'COMPANY', // available
  PRODUCT = 'PRODUCT', // available
  AGENDA = 'AGENDA', // available
  SPEAKER = 'SPEAKER', // available
  PLANNER = 'PLANNER', // available and login
  TIME_AVAILABILITY = 'TIME_AVAILABILITY', // available and login
  SETTINGS = 'SETTINGS', // available and login
  EDIT_PROFILE = 'EDIT_PROFILE', // available and login
  EDIT_COMPANY = 'EDIT_COMPANY', // available and login
  ANALYTICS = 'ANALYTICS', // available and login
  REQUEST_RECEIVED = 'REQUEST_RECEIVED', // available and login
  BOOKMARKED_PEOPLE = 'BOOKMARKED_PEOPLE', // available and login
  BOOKMARKED_COMPANIES = 'BOOKMARKED_COMPANIES', // available and login
  BOOKMARKED_PRODUCTS = 'BOOKMARKED_PRODUCTS', // available and login
  BOOKMARKED_AGENDA = 'BOOKMARKED_AGENDA', // available and login
  ARCHIVED = 'ARCHIVED', // available and login
  REQUEST_SENT = 'REQUEST_SENT', // available and login
  RECOMENDATIONS = 'RECOMENDATIONS', // available and login
  NOTIFICATIONS = 'NOTIFICATIONS', // available and login
  CHAT = 'CHAT', // available and login
  ONDEMAND = 'ONDEMAND',
}

export const JUBLIA_AI_CHATROOM_ID = 'JUDY_AI';
